import { googleTagManagerScripts } from './constants';
import useAnalytics from './hooks/useAnalytics';
import useAuthorizedInfo from './hooks/useAuthorizedInfo';
import { createGaEvent, dispatchGaEvent } from './utils/create-analytics-event';
import { getGaClientId } from './utils/get-ga-clientid';
import { getGaSessionId } from './utils/get-ga-sessionid';
import { analyticsInputHandler } from './utils/input-handler';

// ---

export {
  useAnalytics,
  useAuthorizedInfo,
  analyticsInputHandler,
  googleTagManagerScripts,
  createGaEvent,
  dispatchGaEvent,
  getGaClientId,
  getGaSessionId,
};
